import type { InjectionKey } from 'vue'
import { type UserSlim } from '../../model'

export type UserSelectProvider = {
  getUserSlim: (id: string) => UserSlim | undefined
  loadUserSlims: (filterText: string) => Promise<UserSlim[]>
  ensureUserSlims: (ids: string[]) => Promise<void>
}

export const userSelectProviderKey: InjectionKey<UserSelectProvider> = Symbol('userSelectProvider')
